import { gql } from 'react-apollo';

export default gql`
  mutation updateRealexInvestorSuitability(
    $liquidityNeeds: LiquidityNeeds!
    $riskTolerance: RiskTolerance!
    $yearsOfExperience: YearsOfExperience!
    $investmentFrequency: InvestmentFrequency!
    $investmentAllocation: Float!
    $investmentDecisionConsultProfessional: Boolean
    $investmentDecisionConsultSelf: Boolean
    $investmentDecisionConsultFamilyFriends: Boolean
    $investmentSelectionsConfirmed: Boolean
    $investmentSelectionsRealexPrecentage: Boolean
    $investmentSelectionsRelationshipConfirmed: Boolean
    $userId: ID
  ) {
    updateRealexInvestorSuitability(
      input: {
        liquidityNeeds: $liquidityNeeds
        riskTolerance: $riskTolerance
        yearsOfExperience: $yearsOfExperience
        investmentFrequency: $investmentFrequency
        investmentAllocation: $investmentAllocation
        investmentDecisionConsultProfessional: $investmentDecisionConsultProfessional
        investmentDecisionConsultSelf: $investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends: $investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed: $investmentSelectionsConfirmed
        investmentSelectionsRealexPrecentage: $investmentSelectionsRealexPrecentage
        investmentSelectionsRelationshipConfirmed: $investmentSelectionsRelationshipConfirmed
        userId: $userId
      }
    ) {
      _id
      suitability {
        _id
        liquidityNeeds
        riskTolerance
        yearsOfExperience
        investmentFrequency
        investmentAllocation
        investmentDecisionConsultProfessional
        investmentDecisionConsultSelf
        investmentDecisionConsultFamilyFriends
        investmentSelectionsConfirmed
        investmentSelectionsRealexPrecentage
        investmentSelectionsRelationshipConfirmed
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/updateRealexInvestorSuitability.js